import { useEffect, useState } from "react";

// Free reverse-geocode via BigDataCloud (no API key needed, generous quota).
// Always English (Dubai, UAE). Cached in localStorage for instant paint.
const CC = {
  "United Arab Emirates": "UAE", "Saudi Arabia": "KSA",
  "United Kingdom": "UK", "United States": "USA",
};
const KEY = "city_v1"; const TTL = 24 * 60 * 60 * 1000; // 24h

function normalize(raw) {
  if (!raw) return "";
  const c = raw.replace(/\s*\(the\)\s*/i, "").trim();
  return CC[c] || c;
}

function readCache() {
  try {
    const raw = localStorage.getItem(KEY); if (!raw) return null;
    const { t, d } = JSON.parse(raw);
    return Date.now() - t < TTL ? d : null;
  } catch { return null; }
}

export function useCity() {
  const [place, setPlace] = useState(() => readCache() || { city: "", country: "" });
  useEffect(() => {
    const load = async (lat, lon) => {
      try {
        const url = `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${lat}&longitude=${lon}&localityLanguage=en`;
        const j = await (await fetch(url)).json();
        const d = { city: j.city || j.locality || j.principalSubdivision || "", country: normalize(j.countryName) };
        setPlace(d);
        try { localStorage.setItem(KEY, JSON.stringify({ t: Date.now(), d })); } catch { /* silent */ }
      } catch { /* silent */ }
    };
    if (place.city) return; // cached — skip refresh
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (p) => load(p.coords.latitude, p.coords.longitude),
        () => load(25.276987, 55.296249),
        { timeout: 3000, maximumAge: 1800000 },
      );
    } else load(25.276987, 55.296249);
  }, []);
  return place;
}
